import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import '../../../styles/DocumentDetails.css';
import TopBar from '../../../components/TopBar';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import RefundDetailsPageActionButton from '../components/RefundDetailsPageActionButton';
import RefundForm from '../components/RefundForm';
import IrbmStatusCard from '../../common/IrbmStatusCard';
import { useGetRefundHandler } from '../dataHandlers/getRefundHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';

export default function RefundDetailsPage() {
  useDocumentTitle('Refund Details');
  const { document_id } = useParams();
  const { refund, isLoading } = useGetRefundHandler(document_id);

  if (isLoading || !refund) {
    return <DocumentSkeletonForm />;
  }

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      {refund && (
        <Box sx={{ pb: 4 }}>
          <TopBar title="Refund Details" identifier={refund?.document_id}>
            <RefundDetailsPageActionButton data={refund} />
          </TopBar>
        </Box>
      )}

      <IrbmStatusCard document={refund} />
      <RefundForm onSubmit={() => {}} onCancel={() => {}} initialData={refund} readOnly={true} />
    </Stack>
  );
}
